<template>
	<el-dialog title="下载中心" :visible.sync="isShow" top="7vh" width="80%" append-to-body>
		<div class="download-filter">
			<el-select v-model="queryFilter.type" size="small">
				<el-option v-for="item in typeList" :key="item.keyId" :label="item.name" :value="item.keyId">
				</el-option>
			</el-select>

			<el-date-picker v-model="timeDate" size="small" type="daterange" range-separator="至"
				start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
				@change="pickerChange">
			</el-date-picker>

			<el-button type="primary" class="defaultButton" size="small" @click="search">搜 索</el-button>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column property="createDate" label="操作时间"></el-table-column>
			<el-table-column label="文件名称">
				<template slot-scope="{ row }">
					<p :title="row.fileName" class="ellipsis1">{{ row.fileName }}</p>
				</template>
			</el-table-column>
			<el-table-column property="typeName" label="文件类型"></el-table-column>
			<el-table-column label="文件状态">
				<template slot-scope="{ row }">
					<span :class="{ red: row.state != 1 && row.state != 2 }">
						{{ row.state == 1 ? '生成中' : row.state == 2 ? '已完成' : '生成失败' }}
					</span>
				</template>
			</el-table-column>
			<el-table-column property="createBy" label="操作人"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{ row }">
					<a class="blue" @click="download(row)" v-if="row.state == 2" style="margin-right: 10px;">下载</a>
					<a class="blue" @click="reGenerate(row)" v-if="row.state != 1 && row.state != 2">重新生成</a>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :current-page="queryFilter.pageIndex" :page-size="queryFilter.pageRows" background
			layout="prev, pager, next" :total="queryFilter.total" @current-change="pageChange"
			v-if="queryFilter.total > queryFilter.pageRows">
		</el-pagination>
	</el-dialog>
</template>

<script>
export default {
	name: 'downloadList',
	data() {
		return {
			isShow: false,
			queryFilter: {
				pageIndex: 1,
				pageRows: 10,
				type: null,
				startDate: null,
				endDate: null,
				total: 0
			},
			typeList: [],
			timeDate: [],
			tableData: []
		}
	},
	methods: {
		open() {
			this.$nextTick(() => {
				this.getSystemEnums()
				this.getUserDownloadList()
			})
		},

		getSystemEnums(keys) { // eslint-disable-line no-unused-vars
			this.$request.post('/system/getSystemEnums', {
				keys: ['SS_UserDownloadRefType']
			}).then(res => {
				this.typeList = res.data;

				this.typeList.unshift({
					keyId: null,
					name: '全部类型'
				})
			})
		},

		getUserDownloadList() {
			this.$request.post('/userApi/getUserDownloadList', this.queryFilter).then(res => {
				this.tableData = res.data.data;
				this.queryFilter.total = res.data.total;
				this.isShow = true
			})
		},

		search() {
			this.queryFilter.pageIndex = 1;
			this.getUserDownloadList()
		},

		pickerChange(e) {
			if (e) {
				this.queryFilter.startDate = e[0];
				this.queryFilter.endDate = e[1];
			} else {
				this.queryFilter.startDate = null;
				this.queryFilter.endDate = null;
				this.timeDate = [];
			}
		},

		pageChange(index) {
			this.queryFilter.pageIndex = index;
			this.getUserDownloadList()
		},

		download(item) {
			this.$request.post('/userApi/readedUserDownloadAlert', {
				userDownloadId: item.id
			}).then(res => {
				if (res.succeeded) {
					this.$message({
						message: '下载成功~',
						type: 'success'
					});
					this.$openUrl(item.filePath, '_blank')
				}
			})
		},

		reGenerate(item) {
			this.$request.post('/userApi/ResetGeneratedStudyExport', {
				userDownloadId: item.id
			}).then(res => {
				if (res.succeeded) {
					this.$message({
						message: '正在重新生成中...',
						type: 'success'
					});
					this.getUserDownloadList();
				} else {
					this.$message.error(res.errors || '重新生成失败');
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.el-table {
	margin: 15px 0;
	border-radius: 4px;
	overflow: hidden;

	.red {
		color: #F56C6C;
	}

	.blue {
		color: #0D68FF;
		cursor: pointer;
	}

	::v-deep .el-table__cell {
		text-align: center !important;
	}

	::v-deep .has-gutter {
		color: #333;

		th.el-table__cell {
			background: #F6F8FA;
		}
	}
}
</style>